import React from 'react';
import { useNotifications } from '../context/NotificationContext';

const Notifications = () => {
  const { notifications, unreadCount, markAsRead, markAllAsRead, clearAll } = useNotifications();

  const getTypeColor = (type) => {
    switch(type) {
      case 'announcement': return 'border-l-yellow-500 bg-yellow-500/10';
      case 'dashboard': return 'border-l-blue-500 bg-blue-500/10';
      case 'info': return 'border-l-green-500 bg-green-500/10';
      default: return 'border-l-gray-500 bg-gray-500/10';
    }
  };

  const getTypeLabel = (type) => {
    switch(type) {
      case 'announcement': return 'Ihamberezo';
      case 'dashboard': return 'Dashibodi';
      case 'info': return 'Amakuru';
      default: return 'Ibitekerezo';
    }
  };

  return (
    <div className="min-h-screen bg-black text-white p-4 md:p-6">
      <div className="max-w-4xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 gap-4">
          <div>
            <h1 className="text-2xl font-bold text-white">Amabwiriza</h1>
            <p className="text-gray-400 text-sm mt-1">
              {unreadCount} {unreadCount === 1 ? 'ntibigaritswe' : 'ntibigaritswe'}
            </p>
          </div>
          <div className="flex gap-2">
            {unreadCount > 0 && (
              <button
                onClick={markAllAsRead}
                className="px-4 py-2 bg-gray-800 hover:bg-gray-700 rounded-lg text-sm transition-colors"
              >
                Tanga byose byinshi
              </button>
            )}
            {notifications.length > 0 && (
              <button
                onClick={clearAll}
                className="px-4 py-2 bg-red-900/50 hover:bg-red-800/50 rounded-lg text-sm text-red-400 transition-colors"
              >
                Siba byose
              </button>
            )}
          </div>
        </div>

        {notifications.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-20 text-gray-500">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 mb-4 opacity-50" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
            </svg>
            <p className="text-lg">Nta amabwiriza ahari</p>
            <p className="text-sm text-gray-600 mt-1">Ushobora kubona amabwiriza hano</p>
          </div>
        ) : (
          <div className="space-y-3">
            {notifications.map((notification) => (
              <div
                key={notification.id}
                onClick={() => !notification.read && markAsRead(notification.id)}
                className={`p-4 rounded-lg border-l-4 cursor-pointer transition-all ${getTypeColor(notification.type)} ${notification.read ? 'opacity-60' : 'opacity-100'} hover:bg-gray-900`}
              >
                <div className="flex justify-between items-start">
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-1">
                      <span className={`text-xs px-2 py-0.5 rounded ${notification.type === 'announcement' ? 'bg-yellow-500/20 text-yellow-400' : notification.type === 'dashboard' ? 'bg-blue-500/20 text-blue-400' : 'bg-green-500/20 text-green-400'}`}>
                        {getTypeLabel(notification.type)}
                      </span>
                      {!notification.read && (
                        <span className="w-2 h-2 bg-blue-500 rounded-full animate-pulse"></span>
                      )}
                    </div>
                    <p className="text-white">{notification.message}</p>
                    <p className="text-gray-500 text-xs mt-2">
                      {notification.time}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Notifications;
